import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@mui/material'
import useStyle from 'shared/hooks/useStyle'

import getGlobalAssetUrl from 'shared/utils/getGlobalAssetUrl'
import styles from './TwoRowErrorPage.style'

const propTypes = {
    message: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    iconPath: PropTypes.string.isRequired,
    iconAlt: PropTypes.string.isRequired,
}

const TwoRowErrorPage = ({
    message,
    children,
    iconPath,
    iconAlt,
}) => {
    const classes = useStyle(styles)

    return (
        <div css={classes.main}>
            <div css={classes.icon}>
                <img
                    alt={iconAlt}
                    src={getGlobalAssetUrl(iconPath)}
                    css={classes.image}
                />
            </div>
            <div css={classes.text}>
                <Typography
                    variant="h1"
                    css={classes.message}
                >
                    {message}
                </Typography>
            </div>
            <div css={classes.bottom}>
                {children}
            </div>
        </div>
    )
}

TwoRowErrorPage.propTypes = propTypes

export default TwoRowErrorPage
